export interface MergedConfig {
    textarea: NodeListOf<HTMLTextAreaElement>,
    storage: HTMLInputElement
}

export class Merged {
    private readonly elements: {
        textarea: NodeListOf<HTMLTextAreaElement>,
        storage: HTMLInputElement
    };

    constructor({textarea, storage}: MergedConfig) {
        this.elements = {textarea, storage};
        this.bind();
    }

    protected onTextareaBlur(evt: Event): void {
        const target = evt.target as HTMLTextAreaElement;
        const key = target.getAttribute(`data-key`);
        const id = target.getAttribute(`data-id`);
        this.save(key, id, target.value);
    }

    public save(key: string, id: string, value: string): void {
        const {storage} = this.elements;
        let data = JSON.parse(storage.value);
        data[key][id].value = value;
        storage.value = JSON.stringify(data);
    }

    protected bind(): void {
        this.elements.textarea.forEach(it => {
            it.addEventListener('blur', (evt) => this.onTextareaBlur(evt));
        });
    }
}